import {getLocation} from './validateLocationBeforeReserve';

const LOCATION_TIMEOUT_MS = 12000;
export const END_TRIP_UPLOAD_TIMEOUT_MS = 60000;

export const endTripUploadRequestConfig = {
  timeout: END_TRIP_UPLOAD_TIMEOUT_MS,
};

export function extractUploadedImageId(response) {
  const data = response?.Data ?? response?.data ?? response;
  if (data == null) {
    return null;
  }
  if (typeof data === 'string' || typeof data === 'number') {
    const value = String(data).trim();
    return value ? value : null;
  }
  const id =
    data.id ??
    data.ID ??
    data.Id ??
    data.imageId ??
    data.ImageId ??
    data.ImageID;
  if (id == null) {
    return null;
  }
  const value = String(id).trim();
  return value && value !== 'undefined' && value !== 'null' ? value : null;
}

export function toErrorTypeList(result) {
  if (Array.isArray(result)) {
    return result.filter(Boolean);
  }
  if (typeof result === 'string' && result.trim()) {
    return [result.trim()];
  }
  return [];
}

export function parseEndTripFailure(error, allowedErrors = []) {
  const status = error?.response?.status;
  const result = error?.response?.data?.Result;
  const rawTypes = toErrorTypeList(result);
  const errorMessage =
    error?.message === 'Network Error'
      ? 'Network Error'
      : rawTypes.join('|') || error?.message || 'unknown';
  let error_types = rawTypes.filter(item => allowedErrors.includes(item));
  if (error_types.length === 0) {
    error_types = ['unknown_error_end_trip'];
  }
  return {error_types, rawTypes, status, errorMessage};
}

export function getCoordsForEndTrip(timeoutMs = LOCATION_TIMEOUT_MS) {
  return new Promise(resolve => {
    let settled = false;
    const finish = coords => {
      if (settled) {
        return;
      }
      settled = true;
      resolve({
        latitude: Number(coords?.latitude) || 0,
        longitude: Number(coords?.longitude) || 0,
      });
    };

    const timer = setTimeout(() => {
      finish({latitude: 0, longitude: 0});
    }, timeoutMs);

    getLocation(position => {
      clearTimeout(timer);
      finish(position?.coords);
    });
  });
}

export function shouldRetryUpload(failureCount, error) {
  const message = error?.message != null ? String(error.message) : '';
  return (
    failureCount < 2 &&
    (message === 'Network Error' || message.toLowerCase().includes('timeout'))
  );
}
